import { isVideoLivePath } from "./videoRoomPath";

type WaitingWorker = Pick<
  ServiceWorker,
  "state" | "postMessage" | "addEventListener" | "removeEventListener"
>;

/** Without clients.claim(), activation doesn't emit controlling on existing tabs. */
export async function applyPwaUpdate(input: {
  pathname: () => string;
  registration: () => Promise<
    { waiting: WaitingWorker | null; active: unknown } | undefined
  >;
  reload: () => void;
}): Promise<boolean> {
  if (isVideoLivePath(input.pathname())) return false;
  const registration = await input.registration();
  if (isVideoLivePath(input.pathname())) return false;
  if (!registration)
    throw new Error("Обновление пока недоступно. Попробуйте ещё раз.");
  const worker = registration.waiting;
  if (worker) {
    await new Promise<void>((resolve, reject) => {
      const finish = (error?: Error) => {
        clearTimeout(timer);
        worker.removeEventListener("statechange", changed);
        if (error) reject(error);
        else resolve();
      };
      const changed = () => {
        if (worker.state === "activated") finish();
        else if (worker.state === "redundant")
          finish(
            new Error("Не удалось применить обновление. Попробуйте ещё раз.")
          );
      };
      const timer = setTimeout(
        () =>
          finish(
            new Error("Обновление занимает больше времени. Попробуйте ещё раз.")
          ),
        15000
      );
      worker.addEventListener("statechange", changed);
      try {
        worker.postMessage({ type: "SKIP_WAITING" });
        changed();
      } catch {
        finish(new Error("Не удалось запустить обновление. Попробуйте ещё раз."));
      }
    });
  } else if (!registration.active) {
    throw new Error("Обновление ещё загружается. Попробуйте чуть позже.");
  }
  // A user could enter an interview while the worker was activating.
  if (isVideoLivePath(input.pathname())) return false;
  input.reload();
  return true;
}
